export default __webpack_public_path__ + "partner_93b390e.png";